function Residential_Section6() {
  return <></>;
}

export default Residential_Section6;
